import React from 'react';
import { Tag, TagPrefix } from '@fiverr-private/data_display';
import { Text } from '@fiverr-private/typography';
import type { Skill } from '../../../types';
import { SkillImage } from './SkillImage';

type SkillTagProps = Readonly<Pick<Skill, 'name' | 'iconUrl'>>;

export const SkillTag = ({ name, iconUrl }: SkillTagProps) => (
    <Tag variant="outline" size="sm" ariaLabel={name} href={undefined} target="_blank">
        {iconUrl && (
            <TagPrefix>
                <SkillImage src={iconUrl} />
            </TagPrefix>
        )}
        <Text size="b_sm" fontWeight="semibold">
            {name}
        </Text>
    </Tag>
);
